import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5dxca3j2tp: FaireBrandEntity = {
  token: "b_5dxca3j2tp",
  type: "brand",
  name: "Wildflower Rituals",
  avatarUrl:
    "https://cdn.faire.com/fastly/1d0ceb63d5c1ea09d42be2759151b1d072e24e3eeca358bac4f9757f6235d58d.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/3047090adb97d0d68b069ec3f74559cba59fea604a5639de3280f989196bc684.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1d0ceb63d5c1ea09d42be2759151b1d072e24e3eeca358bac4f9757f6235d58d.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3047090adb97d0d68b069ec3f74559cba59fea604a5639de3280f989196bc684.jpeg",
  location: "Fort Collins, CO, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 28,
  isTopShop: true,
  isInsider: true,
  description:
    "Wildflower Rituals grew out of a desire to bring nature's botanical magic into everyday self-care. We are inspired by wildflower meadows, long soaks in the tub, a cup of herbal tea, sunsets at the end of the day, and the power of scent through pure essential oil aromatherapy.\n\nVision: Prioritizing and celebrating your unique self-care rituals through handmade botanical wellness products is our goal. We believe self-care is essential and strive to make luxury self-care accessible to all.\n\nProducts: We believe less is more when it comes to ingredients. Our small-batch, handmade products are crafted in Colorado using pure essential oils, natural minerals, dried botanicals, and natural textiles. Whenever possible, our ingredients are sustainably sourced and Certified Organic.\n\nCommitment: As a woman-owned business, we proudly partner with fellow women-owned businesses whenever possible and believe supporting one another strengthens our communities.\n\nPromise: We remain committed to ingredient transparency, premium botanicals, and products free from harsh chemicals, synthetic fragrances, and dyes. Our thoughtfully crafted collections help transform everyday routines into meaningful botanical self-care rituals.\n\nDesigned for boutiques, spas, hotels, gift shops, florists, bookstores, yoga studios, and subscription boxes, our botanical self-care collections are highly giftable and created to help customers slow down, & reset.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:59.867Z",
    importedBy: "entity-db-cli",
  },
};
